import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTaxConfig: null,
  taxCalculation: null,
  taxFilters: {
    country: '',
    state: '',
    taxType: '',
    isActive: true,
  },
  taxFormData: {
    taxName: '',
    taxType: '',
    country: '',
    state: '',
    description: '',
    effectiveFrom: '',
    effectiveTo: '',
    slabs: [
      {
        minSalary: 0,
        maxSalary: null,
        fixedAmount: 0,
        percentage: 0,
        description: '',
      },
    ],
    specialConditions: [],
    isActive: true,
  },
  ui: {
    isCreateModalOpen: false,
    isEditModalOpen: false,
    isDeleteModalOpen: false,
    isCalculationModalOpen: false,
    selectedConfigId: null,
  },
};

const taxSlice = createSlice({
  name: 'tax',
  initialState,
  reducers: {
    setSelectedTaxConfig: (state, action) => {
      state.selectedTaxConfig = action.payload;
    },
    setTaxCalculation: (state, action) => {
      state.taxCalculation = action.payload;
    },
    updateTaxFilters: (state, action) => {
      state.taxFilters = { ...state.taxFilters, ...action.payload };
    },
    resetTaxFilters: (state) => {
      state.taxFilters = initialState.taxFilters;
    },
    updateTaxFormData: (state, action) => {
      state.taxFormData = { ...state.taxFormData, ...action.payload };
    },
    addTaxSlab: (state) => {
      state.taxFormData.slabs.push({
        minSalary: 0,
        maxSalary: null,
        fixedAmount: 0,
        percentage: 0,
        description: '',
      });
    },
    updateTaxSlab: (state, action) => {
      const { index, data } = action.payload;
      if (state.taxFormData.slabs[index]) {
        state.taxFormData.slabs[index] = { ...state.taxFormData.slabs[index], ...data };
      }
    },
    removeTaxSlab: (state, action) => {
      const index = action.payload;
      if (state.taxFormData.slabs.length > 1) {
        state.taxFormData.slabs.splice(index, 1);
      }
    },
    addSpecialCondition: (state) => {
      state.taxFormData.specialConditions.push({
        condition: '',
        percentage: 0,
        description: '',
      });
    },
    updateSpecialCondition: (state, action) => {
      const { index, data } = action.payload;
      if (state.taxFormData.specialConditions[index]) {
        state.taxFormData.specialConditions[index] = {
          ...state.taxFormData.specialConditions[index],
          ...data
        };
      }
    },
    removeSpecialCondition: (state, action) => {
      const index = action.payload;
      state.taxFormData.specialConditions.splice(index, 1);
    },
    resetTaxFormData: (state) => {
      state.taxFormData = initialState.taxFormData;
    },
    setCreateModalOpen: (state, action) => {
      state.ui.isCreateModalOpen = action.payload;
    },
    setEditModalOpen: (state, action) => {
      state.ui.isEditModalOpen = action.payload;
    },
    setDeleteModalOpen: (state, action) => {
      state.ui.isDeleteModalOpen = action.payload;
    },
    setCalculationModalOpen: (state, action) => {
      state.ui.isCalculationModalOpen = action.payload;
    },
    setSelectedConfigId: (state, action) => {
      state.ui.selectedConfigId = action.payload;
    },
    resetTaxState: (state) => {
      state.selectedTaxConfig = null;
      state.taxCalculation = null;
      state.ui = initialState.ui;
    },
  },
});

export const {
  setSelectedTaxConfig,
  setTaxCalculation,
  updateTaxFilters,
  resetTaxFilters,
  updateTaxFormData,
  addTaxSlab,
  updateTaxSlab,
  removeTaxSlab,
  addSpecialCondition,
  updateSpecialCondition,
  removeSpecialCondition,
  resetTaxFormData,
  setCreateModalOpen,
  setEditModalOpen,
  setDeleteModalOpen,
  setCalculationModalOpen,
  setSelectedConfigId,
  resetTaxState,
} = taxSlice.actions;

export default taxSlice.reducer;
